export const EVENT_ID_QUERY_PARAM = "eventId"